import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  AggregateSpec,
  AlertAggregateResponse,
  DrilldownStep,
  GroupBySpec,
  HavingSpec,
  OrderingSpec,
  PaginationSpec,
} from '../models/aggregate.models';

export const AggregateActions = createActionGroup({
  source: 'Aggregate',
  events: {
    openAggregate: emptyProps(),
    closeAggregate: emptyProps(),
    setGroupBy: props<{ groupBy: GroupBySpec[] }>(),
    setAggregates: props<{ aggregates: AggregateSpec[] }>(),
    setHaving: props<{ having: HavingSpec[] }>(),
    setOrdering: props<{ ordering: OrderingSpec[] }>(),
    setPagination: props<{ pagination: PaginationSpec }>(),
    pushDrilldown: props<{ step: DrilldownStep }>(),
    toggleGroupSelection: props<{ group: DrilldownStep }>(),
    selectAllGroups: emptyProps(),
    clearGroupSelection: emptyProps(),
    popDrilldown: emptyProps(),
    clearDrilldown: emptyProps(),
    truncateDrilldown: props<{ depth: number }>(),
    runAggregate: emptyProps(),
    loadNextPage: emptyProps(),
    runAggregateSuccess: props<{ response: AlertAggregateResponse }>(),
    runAggregateFailure: props<{ error: string }>(),
    leafAlertsLoaded: emptyProps(),
    markMetricsHavingModified: emptyProps(),
    // localStorage persistence — keyed by user + page; handled in AggregateEffects.
    persistState: props<{ page: string }>(),
    restoreState: props<{ page: string }>(),
    clearPersistedState: props<{ page: string }>(),
  },
});
